import { render } from "./split_table_component.vue?vue&type=template&id=7305f01c"
import script from "./split_table_component.vue?vue&type=script&lang=js"
export * from "./split_table_component.vue?vue&type=script&lang=js"

import "./split_table_component.vue?vue&type=style&index=0&id=7305f01c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__